import { useEffect } from "react";
import { useCmsTheme } from "../cms/useCmsTheme";

const STYLE_ID = "cms-theme-vars";

export default function ThemeInjector() {
  const theme = useCmsTheme();

  useEffect(() => {
    if (!theme) return;

    let el = document.getElementById(STYLE_ID);
    if (!el) {
      el = document.createElement("style");
      el.id = STYLE_ID;
      document.head.appendChild(el);
    }

    el.textContent = buildThemeCSS(theme);
  }, [theme]);

  return null;
}

function buildThemeCSS({ primaryColor, accentColor, fontFamily }) {
  return `
:root {
  --cms-primary: ${primaryColor};
  --cms-accent: ${accentColor};
  --cms-font: ${fontFamily};
}
body {
  font-family: var(--cms-font, Rubik, sans-serif) !important;
}
.btn-success,
.btn-primary {
  background-color: var(--cms-accent) !important;
  border-color: var(--cms-accent) !important;
}
.btn-outline-success,
.btn-outline-primary {
  color: var(--cms-accent) !important;
  border-color: var(--cms-accent) !important;
}
.btn-outline-success:hover,
.btn-outline-primary:hover {
  background-color: var(--cms-accent) !important;
  color: #fff !important;
}
.text-success,
.text-primary {
  color: var(--cms-accent) !important;
}
.bg-success,
.bg-primary {
  background-color: var(--cms-accent) !important;
}
.border-success,
.border-primary {
  border-color: var(--cms-accent) !important;
}
  `.trim();
}
